import { render, staticRenderFns } from "./EditBasicInfo.vue?vue&type=template&id=3239a91e&scoped=true&"
import script from "./EditBasicInfo.vue?vue&type=script&lang=js&"
export * from "./EditBasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./EditBasicInfo.vue?vue&type=style&index=0&id=3239a91e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3239a91e",
  null
  
)

export default component.exports